/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ seconds: NonNullable<unknown> }} Mobile_Auth_Request_Timed_OutInputs */

const en_mobile_auth_request_timed_out = /** @type {(inputs: Mobile_Auth_Request_Timed_OutInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`The request took longer than ${i?.seconds} seconds. Check your connection and try again.`)
};

const es_mobile_auth_request_timed_out = /** @type {(inputs: Mobile_Auth_Request_Timed_OutInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`La solicitud tardó más de ${i?.seconds} segundos. Revisa tu conexión e inténtalo de nuevo.`)
};

/**
* | output |
* | --- |
* | "The request took longer than {seconds} seconds. Check your connection and try again." |
*
* @param {Mobile_Auth_Request_Timed_OutInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_auth_request_timed_out = /** @type {((inputs: Mobile_Auth_Request_Timed_OutInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Auth_Request_Timed_OutInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_auth_request_timed_out(inputs)
	return en_mobile_auth_request_timed_out(inputs)
});